import { Dimensions, Platform } from 'react-native';
import { MarisaAppUtils } from './MarisaAppUtils';

export const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } =
  Dimensions.get('window');

export const callNumber = (phone: string) => {
  if (!isWeb) {
    let phoneNumber = phone;

    if (Platform.OS !== 'android') {
      phoneNumber = `telprompt:${phone}`;
    } else {
      phoneNumber = `tel:${phone}`;
    }

    MarisaAppUtils.openUrl(phoneNumber);
  }
};

export const openEmail = (email: string) => {
  MarisaAppUtils.openUrl(`mailto:${email}`);
};

interface OpenAppStoreParams {
  ios: string;
  android: string;
}

export const openAppStore = ({ ios, android }: OpenAppStoreParams) => {
  if (Platform.OS === 'ios') {
    MarisaAppUtils.openUrl(ios);
  } else {
    MarisaAppUtils.openUrl(android);
  }
};

export const isWeb = Platform.OS === 'web';
